import React from "react";
import { observer } from "mobx-react-lite";
import { Datum } from "plotly.js";
import BasePlot, {
  BasePlotProps,
  barChartColors,
  basePlotlyConfig,
} from "features/Dashboards/Base/BasePlot";
import EmptyState from "components/EmptyState";
import { levelsDashboardStore } from "../LevelsDashboardStore";

const makeConfig = (): BasePlotProps =>
  basePlotlyConfig({
    yaxis: {
      automargin: true,
      visible: true,
      // data arrives descending by GWP; reverse so the largest bar is on top
      autorange: "reversed",
    },
    xaxis: {
      tickmode: "auto",
    },
    hovermode: true,
  });

/** Horizontal bar ranking of the top EPDs by the selected GWP indicator. */
export default observer(function HotspotChart() {
  const traces = levelsDashboardStore.hotspotInfo?.traces ?? [];

  if (!traces.length) {
    return <EmptyState type="chart" noBorder hideMEButton />;
  }

  const config: BasePlotProps = {
    ...makeConfig(),
    data: traces.map((point, index) => ({
      // this endpoint returns x = GWP values, y = EPD names — use directly (no transpose)
      x: (Array.isArray(point.x) ? point.x : []) as Datum[],
      y: (Array.isArray(point.y) ? point.y : []) as Datum[],
      name: point.name,
      orientation: "h",
      type: "bar",
      textposition: "auto",
      width: 0.5,
      marker: { color: barChartColors[index % barChartColors.length] },
      hovertemplate: `%{y}: %{x} <span>kgCO<sub>2</sub>e/m<sup>2</sup><sub>NRF</sub>*a</span><extra></extra>`,
    })) as Partial<Plotly.Data>[],
  };

  return (
    <div className="h-[420px]">
      <BasePlot {...config} />
    </div>
  );
});
